const BasicPlane: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="136.328" height="104" viewBox="0 0 136.328 104">
      <g id="Group_35728" data-name="Group 35728" transform="translate(-1243.429 -409)">
        <path
          id="Path_3430"
          data-name="Path 3430"
          d="M62.334,82.721,19.281,66.77,151.215,37.206l-23.821,72.527L76.987,87.613,105.7,64Z"
          transform="translate(1227.014 373.319)"
          fill="#fff"
        />
        <path
          id="Path_3431"
          data-name="Path 3431"
          d="M26.027,59.24l-1.615,25.4,14.477-6.469L40.68,64.133,69.393,40.524Z"
          transform="translate(1263.321 396.806)"
          fill="#fff"
        />
        <path
          id="Path_3432"
          data-name="Path 3432"
          d="M28,43.447,26.2,70.244l26.712-15.57Z"
          transform="translate(1276.004 417.482)"
          fill="#fff"
        />
        <path
          id="Path_3433"
          data-name="Path 3433"
          d="M101.124,37.154,74.956,103.139l-47.293-16.5L26.4,87.753l50.7,23Z"
          transform="translate(1277.42 372.951)"
          fill="#cad7ef"
        />
        <path
          id="Path_3434"
          data-name="Path 3434"
          d="M26.427,49.271l21.332,8.157,3.559-2.451L26.4,43.419Z"
          transform="translate(1277.42 417.283)"
          fill="#cad7ef"
        />
        <path
          id="Path_3435"
          data-name="Path 3435"
          d="M24.639,72.417,54.782,53.8,70.063,40.311,24.612,60.338Z"
          transform="translate(1264.735 395.3)"
          fill="#cad7ef"
        />
        <path
          id="Path_3436"
          data-name="Path 3436"
          d="M68.716,52.911c0-2.213-10.03-4.006-22.4-4.006S23.919,50.7,23.919,52.911s10.03,4.014,22.394,4.014S68.716,55.123,68.716,52.911Z"
          transform="translate(1259.832 456.076)"
          fill="#cad7ef"
        />
        <g id="Group_1233" data-name="Group 1233" transform="translate(1243.429 409)">
          <path
            id="Path_3437"
            data-name="Path 3437"
            d="M76.926,117.263l.743-13.319-15.263,7.177,1.6-26.889L18.926,67.9,155.254,37.017l-24.744,75.874-25.98-11.8ZM80.06,89.986,78.7,114.345l24.026-14.071Zm-1.478-2.449,50.958,23.131,23.291-71.445L24.66,68.254,65.685,83.125,64.175,108.5l13.592-6.393Z"
            transform="translate(-18.926 -37.017)"
            fill="#545f7f"
          />
        </g>
      </g>
    </svg>
  );
};

export default BasicPlane;
